import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const checkPostal = (postal_code) =>
  api.post("/service-area/check", { postal_code }).then((r) => r.data);
export const fetchTestimonials = () => api.get("/testimonials").then((r) => r.data.testimonials);
export const fetchHomestarsReviews = () =>
  api.get("/reviews/homestars").then((r) => r.data);
export const fetchFaqs = () => api.get("/faqs").then((r) => r.data.faqs);
export const fetchPricing = () => api.get("/pricing").then((r) => r.data);
export const fetchAvailability = (days = 14) =>
  api.get(`/availability?days=${days}`).then((r) => r.data);
export const createCheckoutSession = (payload) =>
  api.post("/checkout/session", payload).then((r) => r.data);
export const checkoutStatus = (session_id) =>
  api.get(`/checkout/status/${session_id}`).then((r) => r.data);
